import React, { useReducer } from "react";
import light from "../theme/lightTheme";
import dark from "../theme/darkTheme";
import mapStylesLight from "../theme/mapStylesLight"; //style of map what to show what colors should stuff have
import mapStylesDark from "../theme/mapStylesDark"; //style of map what to show what colors should stuff have

export const Reducer = (state: StoreType, action: any) => {
  switch (action.type) {
    case "CHANGE_THEME":
      console.log("hey");
      if (action.theme == light) return { ...state, theme: dark, mapTheme: mapStylesDark };
      else return { ...state, theme: light, mapTheme:mapStylesLight };
    
    case "CHANGE_LOCATION":
      console.log("hello");
      return { ...state, lat: action.newLat, lng: action.newLng };

    case "RESET_LOCATION":
      console.log("greetings");
      return { ...state, lat: 0, lng: 0 };
      
    default:
      return state;
  }
};

interface StoreType {
  theme: {};
  mapTheme: {};
  lat: number;
  lng: number;
}

const initState: StoreType = {
  theme: light,
  mapTheme: mapStylesLight,
  lat: 0,
  lng: 0,
};

export const Context = React.createContext<{
  store: StoreType;
  dispatch: Function;
}>({
  store: initState,
  dispatch: () => {},
});

export const Store = ({ children }: any) => {
  const [store, dispatch] = useReducer(Reducer, initState);

  return (
    <Context.Provider value={{ store, dispatch }}>{children}</Context.Provider>
  );
};
